import React from 'react';
import Layout from '../../features/Layout';
import PrivacyPolicy from '../../components/PrivacyPolicy';

const Privacy = ({ isProd }) => {
  return (
    <Layout
      title="Khatabook - Our Apps"
      description="Digital India's Digital Khata! Download Khatabook now & take charge of all your transactions, use Khatabook and grow your business!"
      isProd={isProd}
    >
      <PrivacyPolicy />
    </Layout>
  );
};

export default Privacy;
